import {IntermediatePart} from "../../intermediatePart";
import Cabinet from "../../parts/cabinet";

export default class Decor1 extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'decor_1';
    this.partName = 'Decor1';
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Decor1());
  }

  setLayers(layout) {

    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const bottomCabinet = cabinetParent && cabinetParent.bottomCabinet;
    if (bottomCabinet && (bottomCabinet.disabled || !bottomCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.Decor1;
    }
  }
}